import { PersonalData } from './PersonalMockData';

export function setupPersonalMock(mock) {
    mock.onGet('/personal').reply(200, PersonalData);
};